import { createSelector } from 'reselect';

const GAMEDAY_TYPES_LIMITED = ['P', 'E'];

const EMPTY = {};

const getIsLoading = (state) => {
    return !!state.loading?.isLoading;
};

const getLive = (state) => {
    return state.live?.numberOfPlays ?? 0;
};

const getGameTab = (state) => {
    const {
        views: {
            game_tab
        } = {}
    } = state;

    return game_tab;
};

const getIsLimitedExperience = (state) => {
    return !(GAMEDAY_TYPES_LIMITED.includes(state.gumbo?.gameData?.game?.gamedayType));
};

const getAppViewHelper = (state) => state?.config?.appView;

const getConfigGameContext = (state) => state?.config?.context?.gameContext ?? state?.config?.failsafeGameContext;

const getConfigEnableTabsLive = (state) => state?.config?.enableTabsLive ?? EMPTY;

const getGameState = (state) => {
    const {
        gumbo: {
            gameData: {
                status: {
                    abstractGameState
                } = {}
            } = {}
        } = {}
    } = state;

    return abstractGameState;
};

export const getLiveState = createSelector(
    [getLive, getIsLoading, getGameTab, getGameState, getIsLimitedExperience, getConfigEnableTabsLive],
    (numberOfPlays, isLoading, game_tab, abstractGameState, isLimitedExperience, enableTabsLive) => ({ numberOfPlays, isLoading, game_tab, abstractGameState, isLimitedExperience, enableTabsLive })
);

export const getAppView = createSelector(
    [getAppViewHelper],
    (appView) => ({ appView })
);
